module.exports = __webpack_public_path__ + "img/ad-jl.7e2662fb.png";